import { Box, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import { Authorized } from 'modules/core/components/Authorized'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { acceptedContentTypes } from 'modules/core/lib/fileFormats'
import i18n from 'modules/core/lib/i18n'

import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'
import FileList from 'modules/documents/components/FileList'
import { WizardData } from 'modules/documents/components/UploadFormWizard/types'

const FileUploader = ({ data, onDataChanged }: WizardStepRenderParams<WizardData>) => {
  const {
    company: { subscription },
  } = useCurrentSession()
  const { files } = data

  return (
    <Box flexDirection="row" justifyContent="center">
      <Box gap="s16" width="s600">
        <Text size="200" weight="medium" color="grey1000">
          {i18n.t('split_documents.form.documents')}
        </Text>
        <Authorized subscription={subscription}>
          <DropzoneBox
            onDrop={(newFiles) => {
              onDataChanged({ ...data, files: files.concat(newFiles) })
            }}
            message={i18n.t('documents.drop_here')}
            accept={acceptedContentTypes()}
            iconName={'common-file-text-upload'}
          />
        </Authorized>
        <FileList
          files={files}
          onDeleteFile={(index) => {
            onDataChanged({ ...data, files: files.filter((_, i) => i !== index) })
          }}
          spaced={false}
        />
      </Box>
    </Box>
  )
}

export default FileUploader
